<div  mat-dialog-content *ngIf="data && data.type !== 'deleteServiceProvider'">
  <p style="font-weight: bold; font-size: 1.2rem">
    Configuration for Supplier To Supplier Delivered Parts
  </p>
  <form class="example-form" [formGroup]="configForm">
    <div>
      <mat-form-field>
        <input
          matInput
          placeholder="Service Provider En *"
          formControlName="serviceProvierEn"
        />

        <mat-error
          *ngIf="
            getAddFormFieldsName('serviceProvierEn').hasError('required') ||
            getAddFormFieldsName('serviceProvierEn').hasError('pattern')
          "
        >
          {{ getPrefecErrorMessage(configForm.get("serviceProvierEn")) }}
        </mat-error>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <input
          matInput
          placeholder="Service Provider Jp *"
          formControlName="serviceProviderJp"
          required
        />

        <mat-error
          *ngIf="
            getAddFormFieldsName('serviceProviderJp').invalid &&
            (getAddFormFieldsName('serviceProviderJp').dirty ||
              getAddFormFieldsName('serviceProviderJp').touched)
          "
        >
          <mat-error
            *ngIf="
              getAddFormFieldsName('serviceProviderJp').hasError('required')
            "
            >{{
              getPrefecErrorMessage(configForm.get("serviceProvierEn"))
            }}</mat-error
          >
          <mat-error
            *ngIf="
              getAddFormFieldsName('serviceProviderJp').hasError('pattern')
            " >{{
              "Only Japanese Text Allowed"
            }}</mat-error
          >
        </mat-error>
      </mat-form-field>
    </div>
  </form>
</div>
<div mat-dialog-content *ngIf="data.type == 'deleteServiceProvider'">
  <h1 mat-dialog-title>Delete Service Provider Information</h1>
  <p>Are you sure that you want to delete below service provider.</p>
  <p>Service Provider Jp: {{ data.serviceProviderData.serviceProviderJp }}</p>
  <p>Service Provider En: {{ data.serviceProviderData.serviceProvider }}</p>
</div>
<br />
<div  mat-dialog-actions >
  <button *ngIf="data.type=='addServiceProvider'"
    mat-button
    style="background-color: rgb(211, 209, 209)"
    cdkFocusInitial
    [disabled]="data.type=='deleteServiceProvider'?false:configForm.invalid"
    (click)="onSubmit()"
  >
    Ok
  </button>
  <button *ngIf="data.type=='deleteServiceProvider'"
    mat-button
    style="background-color: rgb(211, 209, 209)"
    cdkFocusInitial
    (click)="onSubmit()"
  >
    Delete
  </button>
  <button *ngIf="data.type=='editServiceProvider'"
  mat-button
  style="background-color: rgb(211, 209, 209)"
  cdkFocusInitial
  [disabled]="data.type=='deleteServiceProvider'?false:configForm.invalid"
  (click)="onSubmit()"
>
  EDIT
</button>
  <button
    mat-button
    style="background-color: rgb(240, 237, 237)"
    (click)="onNoClick()"
  >
    Close
  </button>
</div>
